// @mui
import {
  Box,
  Button,
  Container,
  Typography,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Autocomplete,
  TextField,
  CircularProgress,
} from '@mui/material';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';

//
import PropTypes from 'prop-types';
import '../../styles/dashboard.scss';

// _mock
// hooks
// components
import { useSettingsContext } from 'src/components/settings';

//
import { useAirwayBillActions } from 'src/context/providers/AirwayBillContext';
import { debounce } from 'lodash';
import UploadImageComponent from 'src/custom_components/Froms/imageContentUpload';
import { useOrderActions } from 'src/context/providers/OrderContext';
import Iconify from 'src/components/iconify';
import { useCallback, useEffect, useState } from 'react';
import DownloadForRS from './downloadForRS';
import DownloadForRSPersonal from './downloadForRSPersonal';

export default function TcTable({ TABLE_HEAD, defaultFilters, tableNames, kanbanInput }) {
  const settings = useSettingsContext();
  const [rsData, setRsData] = useState({});
  const [rsDataPersonal, setRsDataPersonal] = useState({});
  const [files, setFiles] = useState([]);
  const [filesPhysical, setFilesPhysical] = useState([]);
  const [selectedPallets, setSelectedPallets] = useState([]);
  const [selectedPalletIds, setSelectedPalletIds] = useState([]);
  const { getAirwayBills } = useAirwayBillActions();
  const [airwayBill, setAirwayBill] = useState({
    id: '',
    tracking: '',
  });
  // Secondary select states
  const [airwayBillPersonal, setAirwayBillPersonal] = useState({
    id: '',
    tracking: '',
  });
  const [selectedPalletsPersonal, setSelectedPalletsPersonal] = useState([]);
  const [selectedPalletIdsPersonal, setSelectedPalletIdsPersonal] = useState([]);
  // Custom
  const [airwaybillOptions, setAirwaybillOptions] = useState([]);
  const [airwaybillOptionsPersonal, setAirwaybillOptionsPersonal] = useState([]);
  const [loadingAWB, setLoadingAWB] = useState(false);
  const [loadingAWBPersonal, setLoadingAWBPersonal] = useState(false);
  const setAirwayBillValue = (e) => {
    setAirwayBill(e);
    setSelectedPallets(e?.pallets);
    setSelectedPalletIds([]);
  };
  const setAirwayBillValuePersonal = (e) => {
    setAirwayBillPersonal(e);
    setSelectedPalletsPersonal(e?.pallets);
    setSelectedPalletIdsPersonal([]);
  };
  const { getRSOrders, getRSOrdersPersonal, sendFile, sendFilePhysical } = useOrderActions();
  const [loading, setLoading] = useState(false);
  const [loadingPhysical, setLoadingPhysical] = useState(false);
  const sendFilesTORS = async () => {
    if (files.length) {
      setLoading(true); // Set loading state to true
      try {
        await sendFile(files);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };
  const sendFilesTORSPhysical = async () => {
    if (filesPhysical.length) {
      setLoadingPhysical(true); // Set loading state to true
      try {
        await sendFilePhysical(filesPhysical);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingPhysical(false);
      }
    }
  };
  const handlePalletChange = (palletId) => {
    setSelectedPalletIds((prevSelectedPalletIds) => {
      if (prevSelectedPalletIds.includes(palletId)) {
        return prevSelectedPalletIds.filter((id) => id !== palletId);
      }
      return [...prevSelectedPalletIds, palletId];
    });
  };
  const handlePalletChangePersonal = (palletId) => {
    setSelectedPalletIdsPersonal((prevSelectedPalletIds) => {
      if (prevSelectedPalletIds.includes(palletId)) {
        return prevSelectedPalletIds.filter((id) => id !== palletId);
      }
      return [...prevSelectedPalletIds, palletId];
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      if (selectedPalletIds.length) {
        try {
          const data = await getRSOrders(selectedPalletIds);
          setRsData(data);
        } catch (error) {
          console.error('Failed to fetch RS orders:', error);
        }
      }
    };
    fetchData();
  }, [selectedPalletIds, getRSOrders]);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedPalletIdsPersonal.length) {
        try {
          const data = await getRSOrdersPersonal(selectedPalletIdsPersonal);
          setRsDataPersonal(data);
        } catch (error) {
          console.error('Failed to fetch RS orders (personal):', error);
        }
      }
    };
    fetchData();
  }, [selectedPalletIdsPersonal, getRSOrdersPersonal]);

  const fetchAWB = useCallback(
    async (filters) => {
      setLoadingAWB(true);
      try {
        const response = await getAirwayBills(filters);
        setAirwaybillOptions(response?.airwaybills);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingAWB(false);
      }
    },
    [getAirwayBills]
  );
  const fetchAWBPersonal = useCallback(
    async (filters) => {
      setLoadingAWBPersonal(true);
      try {
        const response = await getAirwayBills(filters);
        setAirwaybillOptionsPersonal(response?.airwaybills);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingAWBPersonal(false);
      }
    },
    [getAirwayBills]
  );

  useEffect(() => {
    const initialFilters = {
      take: 5,
    };
    fetchAWB(initialFilters);
    fetchAWBPersonal(initialFilters);
  }, [fetchAWB, fetchAWBPersonal]);
  // Fetch pallet data based on input

  const handleAWBInputChange = debounce((event, newInputValue) => {
    const filters = {
      tracking: newInputValue,
      take: 5,
    };
    fetchAWB(filters);
  }, 500);
  const handleAWBInputChangePersonal = debounce((event, newInputValue) => {
    const filters = {
      tracking: newInputValue,
      take: 5,
    };
    fetchAWBPersonal(filters);
  }, 500);

  return (
    <div>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs heading="RS" sx={{ padding: '0px 3%' }} />
        <div className="select_containers_large">
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <div
              className="child_kanban_large"
              style={
                settings.themeMode === 'light'
                  ? { backgroundColor: '#f4f6f8', flex: '1 1 520px' }
                  : { backgroundColor: '#2D353D', flex: '1 1 520px' }
              }
            >
              <Typography variant="h6">Download Data For RS</Typography>
              <Box className="headings">
                <div
                  className="little_input_boxes"
                  style={{
                    backgroundColor: settings.themeMode === 'light' ? '#ffffff' : '#161C24',
                  }}
                >
                  <div style={{ width: '80%' }}>
                    <Autocomplete
                      options={airwaybillOptions}
                      getOptionLabel={(option) => option.tracking || ''}
                      value={airwayBill}
                      onChange={(event, newValue) => setAirwayBillValue(newValue)}
                      onInputChange={handleAWBInputChange}
                      loading={loadingAWB}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="AWB Tracking"
                          variant="filled"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingAWB ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                    <FormGroup>
                      {selectedPallets?.map((pallet, index) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedPalletIds.includes(pallet.id)}
                              onChange={() => handlePalletChange(pallet.id)}
                              value={pallet.id}
                            />
                          }
                          label={pallet.tracking}
                          key={index}
                        />
                      ))}
                    </FormGroup>
                  </div>
                  <DownloadForRS rsData={rsData} />
                </div>
              </Box>
            </div>

            <div
              className="child_kanban_large"
              style={
                settings.themeMode === 'light'
                  ? { backgroundColor: '#f4f6f8', flex: '1 1 520px' }
                  : { backgroundColor: '#2D353D', flex: '1 1 520px' }
              }
            >
              <Typography variant="h6">Download Data For RS (Personal)</Typography>
              <Box className="headings">
                <div
                  className="little_input_boxes"
                  style={{
                    backgroundColor: settings.themeMode === 'light' ? '#ffffff' : '#161C24',
                  }}
                >
                  <div style={{ width: '80%' }}>
                    <Autocomplete
                      options={airwaybillOptionsPersonal}
                      getOptionLabel={(option) => option.tracking || ''}
                      value={airwayBillPersonal}
                      onChange={(event, newValue) => setAirwayBillValuePersonal(newValue)}
                      onInputChange={handleAWBInputChangePersonal}
                      loading={loadingAWBPersonal}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="AWB Tracking (Personal)"
                          variant="filled"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingAWBPersonal ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                    <FormGroup>
                      {selectedPalletsPersonal?.map((pallet, index) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedPalletIdsPersonal.includes(pallet.id)}
                              onChange={() => handlePalletChangePersonal(pallet.id)}
                              value={pallet.id}
                            />
                          }
                          label={pallet.tracking}
                          key={index}
                        />
                      ))}
                    </FormGroup>
                  </div>
                  <DownloadForRSPersonal rsData={rsDataPersonal} />
                </div>
              </Box>
            </div>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', marginTop: '70px' }}>
            <div
              className="child_kanban_large"
              style={{
                backgroundColor: settings.themeMode === 'light' ? '#f4f6f8' : '#2D353D',
                flex: '1 1 520px',
              }}
            >
              <Typography variant="h6">Upload Data From RS</Typography>
              <Box className="headings">
                <div
                  className="little_input_boxes"
                  style={{
                    backgroundColor: settings.themeMode === 'light' ? '#ffffff' : '#161C24',
                  }}
                >
                  <UploadImageComponent files={files} setFiles={setFiles} hasPadding={false} />
                  <Button
                    onClick={sendFilesTORS}
                    variant="contained"
                    disabled={!files?.length || loading}
                    startIcon={
                      loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <Iconify icon="material-symbols:upload" />
                      )
                    }
                    style={{ fontSize: '0.7rem' }}
                  >
                    {loading ? 'Uploading...' : 'UPLOAD'}
                  </Button>
                </div>
              </Box>
            </div>
            <div
              className="child_kanban_large"
              style={{
                backgroundColor: settings.themeMode === 'light' ? '#f4f6f8' : '#2D353D',
                flex: '1 1 520px',
              }}
            >
              <Typography variant="h6">Upload Data From RS (Physical)</Typography>
              <Box className="headings">
                <div
                  className="little_input_boxes"
                  style={{
                    backgroundColor: settings.themeMode === 'light' ? '#ffffff' : '#161C24',
                  }}
                >
                  <UploadImageComponent
                    files={filesPhysical}
                    setFiles={setFilesPhysical}
                    hasPadding={false}
                  />
                  <Button
                    onClick={sendFilesTORSPhysical}
                    variant="contained"
                    disabled={!filesPhysical?.length || loadingPhysical}
                    startIcon={
                      loadingPhysical ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <Iconify icon="material-symbols:upload" />
                      )
                    }
                    style={{ fontSize: '0.7rem' }}
                  >
                    {loadingPhysical ? 'Uploading...' : 'UPLOAD PHYSICAL'}
                  </Button>
                </div>
              </Box>
            </div>
          </Box>
        </div>
      </Container>
    </div>
  );
}

TcTable.propTypes = {
  TABLE_HEAD: PropTypes.array,
  defaultFilters: PropTypes.object,
  tableNames: PropTypes.array,
  kanbanInput: PropTypes.array,
};
